import { h } from 'preact'
import { useMemo } from 'preact/hooks'
import { useStateValue } from '../../state-management/store'
import { BookingStep, PatientType } from '../../models/enums'
import { StepBody } from '../step-body'
import { SelfSchedulerFooter } from '../self-scheduler-footer'
import PatientTypeTile from './patient-type'
import { newPatientIcon, existingPatientIcon } from '../../shared/svgIcons'
import * as style from './style.css'

const PatientTypeSelector: preact.FunctionalComponent = () => {
    const [{ patientType, locations, selectedLocationId }, dispatch] = useStateValue()
    const selectedLocationData = locations.find((location) => location.id === selectedLocationId)

    const handleSetPatientType = (nextPatientType: PatientType) => () => {
        dispatch({
            type: 'CHANGE_PATIENT_TYPE',
            patientType: nextPatientType,
        })
    }

    const skipLocationsScreen = locations.length === 1 && locations[0].onlineSchedulingEnabled

    const formattedAddress = useMemo(() => {
        if (!selectedLocationData) {
            return ''
        }

        const address = []
        const addressStateAndZip = []

        if (selectedLocationData.street) {
            address.push(
                `${selectedLocationData.street}${!selectedLocationData.unit ? '' : `, ${selectedLocationData.unit}`}`
            )
        }

        if (selectedLocationData.city) {
            address.push(selectedLocationData.city)
        }

        if (selectedLocationData.state) {
            addressStateAndZip.push(selectedLocationData.state)
        }

        if (selectedLocationData.zip) {
            addressStateAndZip.push(selectedLocationData.zip)
        }

        const addressLastPartString = addressStateAndZip.join(' ')
        address.push(addressLastPartString)

        return address.join(', ')
    }, [selectedLocationData])

    return (
        <section class={style.patientTypeSelectorContainer}>
            <StepBody>
                <div class={style.patientTypeSelectorWrapper}>
                    <div class={style.patientTypeSelectedLocation}>
                        <div class={style.patientTypeSelectedLocationName}>{selectedLocationData?.name}</div>
                        <div class={style.patientTypeSelectedLocationAddress}>{formattedAddress}</div>
                    </div>
                    <div class={style.patientTypeSelector}>
                        <PatientTypeTile
                            icon={newPatientIcon}
                            isSelected={patientType === PatientType.NEW}
                            onClick={handleSetPatientType(PatientType.NEW)}
                        >
                            No, I have not.
                        </PatientTypeTile>
                        <PatientTypeTile
                            icon={existingPatientIcon}
                            isSelected={patientType === PatientType.EXISTING}
                            onClick={handleSetPatientType(PatientType.EXISTING)}
                        >
                            Yes, I have.
                        </PatientTypeTile>
                    </div>
                </div>
            </StepBody>
            <SelfSchedulerFooter
                backStep={!skipLocationsScreen ? BookingStep.LOCATION : undefined}
                nextStep={BookingStep.DETAILS}
                isNextDisabled={patientType === undefined}
            />
        </section>
    )
}

export default PatientTypeSelector
